import React from 'react';
import { Layout, Result, Typography, Card } from 'antd';
import { ClockCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';

const { Content } = Layout;
const { Text, Paragraph } = Typography;

const TokenExpiredPage = ({ expired = false, error = null }) => {
    const isExpired = expired || (error && error.toLowerCase().includes('expired'));

    return (
        <Layout style={{ minHeight: '100vh', background: '#f5f5f5' }}>
            <Content style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: 40
            }}>
                <Card
                    style={{
                        maxWidth: 500,
                        width: '100%',
                        textAlign: 'center',
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
                    }}
                >
                    <Result
                        icon={isExpired
                            ? <ClockCircleOutlined style={{ color: '#faad14', fontSize: 72 }} />
                            : <ExclamationCircleOutlined style={{ color: '#ff4d4f', fontSize: 72 }} />
                        }
                        title={isExpired ? 'Link Expired' : 'Access Denied'}
                        subTitle={
                            isExpired
                                ? 'This document access link has expired.'
                                : error || 'This link is invalid or has already been used.'
                        }
                    />

                    <div style={{
                        background: '#fafafa',
                        padding: 20,
                        borderRadius: 8,
                        marginTop: 16
                    }}>
                        <Text strong style={{ display: 'block', marginBottom: 12 }}>
                            What to do next:
                        </Text>
                        <Paragraph type="secondary" style={{ marginBottom: 8 }}>
                            Please contact the person who sent you this document and ask them to resend a new link.
                        </Paragraph>
                        <Paragraph type="secondary" style={{ marginBottom: 0 }}>
                            Document links expire after 12 hours for security reasons.
                        </Paragraph>
                    </div>

                    <div style={{ marginTop: 24 }}>
                        <Text type="secondary" style={{ fontSize: 12 }}>
                            If you believe this is an error, please contact support.
                        </Text>
                    </div>
                </Card>
            </Content>
        </Layout>
    );
};

export default TokenExpiredPage;
